/* unplugin-vue-components disabled */import script from "./head.vue?vue&type=script&setup=true&lang=ts"
export * from "./head.vue?vue&type=script&setup=true&lang=ts"

import "./head.vue?vue&type=style&index=0&id=1b46fb56&lang=less&scoped=true"

import exportComponent from "E:\\guanwnag\\hzzn.group.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b46fb56"]])

export default __exports__